import { getCSRFToken } from "./authService";

export const getStencilData = async () => {
  const response = await fetch("/api/stencils", {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();
  return data;
};

export const getStencil = async (id) => {
  const response = await fetch(`/api/stencils/id/${id}`, {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();
  return data;
};

export const uploadStencil = async (
  id,
  name,
  category_id,
  subcategory,
  source,
  img,
  pdf
) => {
  try {
    const token = await getCSRFToken();

    const pdfBlob = new Blob([pdf], { type: "application/pdf" });
    const imgBlob = new Blob([img], { type: "image/jpeg" });

    const form = new FormData();
    form.append("id", id);
    form.append("name", name);
    form.append("category_id", category_id);
    form.append("subcategory", subcategory);
    form.append("pdf", pdfBlob, `${id}.pdf`);
    form.append("img", imgBlob, `${id}.jpg`);
    form.append("source", source);

    const response = await fetch("/api/stencils", {
      method: "POST",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error uploading stencil:", error);
  }
};

export const updateStencil = async (stencil) => {
  try {
    const token = await getCSRFToken();

    const pdfBlob = new Blob([stencil.pdf], { type: "application/pdf" });
    const imgBlob = new Blob([stencil.img], { type: "image/jpeg" });

    const form = new FormData();
    form.append("id", stencil.id);
    form.append("name", stencil.name);
    form.append("category_id", stencil.category_id);
    form.append("subcategory", stencil.subcategory);
    form.append("pdf", pdfBlob, `${stencil.id}.pdf`);
    form.append("img", imgBlob, `${stencil.id}.jpg`);
    form.append("source", stencil.source);

    const response = await fetch(`/api/stencils/${stencil.id}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error uploading stencil:", error);
  }
};

export const deleteStencil = async (stencilID) => {
  const token = await getCSRFToken();

  try {
    const response = await fetch(`/api/stencils/${stencilID}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("Error deleting stencil:", error);
  }
};

export const archiveStencil = async (stencilID, status) => {
  const token = await getCSRFToken();

  const form = new FormData();
  form.append("archived", status);
  
  try {
    const response = await fetch(`/api/stencils/set-archived/${stencilID}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error archiving stencil:", error);
  }
};
